import React from "react";

export default function FourOhFour() {

    return (
        <div>NotFound</div>
    );
}